(function() {
	if (window.octopusTeamMemberModalInit) {
		return;
	}

	window.octopusTeamMemberModalInit = true;

	function setTriggerState(dialog, isActive) {
		if (!dialog || !dialog.id) {
			return;
		}

		var trigger = document.querySelector('[data-modal-target="' + dialog.id + '"]');
		if (!trigger) {
			return;
		}

		trigger.classList.toggle('is-active', isActive);
		trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
	}

	document.addEventListener('click', function(event) {
		var trigger = event.target.closest('[data-modal-target]');
		if (trigger) {
			var dialogId = trigger.getAttribute('data-modal-target');
			var dialog = document.getElementById(dialogId);
			if (dialog && typeof dialog.showModal === 'function') {
				if (!dialog.dataset.modalBound) {
					dialog.addEventListener('close', function() {
						setTriggerState(dialog, false);
					});
					dialog.dataset.modalBound = '1';
				}

				dialog.showModal();
				setTriggerState(dialog, true);
			}
			return;
		}

		var closeButton = event.target.closest('[data-modal-close]');
		if (closeButton) {
			var closeDialog = closeButton.closest('dialog');
			if (closeDialog) {
				setTriggerState(closeDialog, false);
				closeDialog.close();
			}
			return;
		}

		var openDialog = event.target.closest('dialog[open]');
		if (openDialog) {
			var rect = openDialog.getBoundingClientRect();
			var clickedInside = rect.top <= event.clientY && event.clientY <= rect.bottom && rect.left <= event.clientX && event.clientX <= rect.right;
			if (!clickedInside) {
				setTriggerState(openDialog, false);
				openDialog.close();
			}
		}
	});
})();
